import { Link } from "gatsby"
import React from "react"

import TwitterIcon from "../images/footer-twitter.svg"
import FacebookIcon from "../images/footer-facebook.svg"
import InstagramIcon from "../images/footer-instagram.svg"

const links = ["home", "portfolio", "about", "blog", "contact", "clients area"]

const icons = [TwitterIcon, FacebookIcon, InstagramIcon]

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#080618] z-10 w-full">
      <div className="desktop bg-transparent text-white flex justify-center py-6 flex-wrap md:py-[40px] md:justify-between lg:flex-nowrap">
        <p className="m-0 font-ubuntu text-sm mb-3 w-full text-center md:text-left md:w-auto md:mb-0 lg:text-[12px]">
          copyright © {currentYear}
        </p>

        <div className="flex w-9/12 flex-wrap justify-center md:flex-nowrap md:justify-end md:w-10/12 lg:w-9/12">
          <div className="flex flex-wrap w-full mb-5 md:mb-0 md:flex-nowrap md:justify-between md:w-[69%] md:mr-[72px] xl:w-6/12">
            {links.map(link => (
              <Link
                className="text-base text-white w-1/3 md:w-full md:text-[14px]"
                key={link}
                to="/"
              >
                {link}
              </Link>
            ))}
          </div>

          <div className="flex">
            {icons.map(icon => (
              <img
                className="mb-0 mr-4 last:mr-0 lg:mr-[12px]"
                width={20}
                src={icon}
                alt="social icon"
                key={icon}
              />
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
